export default function keystopper(key, fn, def) {
  if (typeof fn === 'function') {
    return function() {
      if (this.$store.state.keyed === key) {
        fn.call(this);
      }
    }.bind(this)
  } else {
    if (this.$store.state.keyed === key) {
      return fn;
    } else {
      return def;
    }
  }
}
